import AddToCart from "./index";
import Notification from "../Notification";
import addToCartSuccessMessageHtml from "./addToCartSuccessMessage.html";

/**
 * Use notifications for success messages.
 */
export default class NotificationAddToCart extends AddToCart {
  constructor(container) {
    super(container);

    this.error = this.error.bind(this);
  }

  get title() {
    return this.container.querySelector("[data-target=title]").textContent;
  }

  get primaryImageSrc() {
    return (
      this.container.querySelector("img").src || this.product.primaryImageSrc
    );
  }

  successMessage() {
    new Notification({
      imageUrl: this.primaryImageSrc,
      heading: addToCartSuccessMessageHtml(this.product.quantity),
      href: "/viewcart.cfm",
      body: this.title,
      buttonText: "View Cart",
      secondButtonText: "Checkout",
      secondHref: "/viewinfo.cfm",
    });
  }

  error(error) {
    Notification.closeAll();
    super.error(error);
  }
}
